//@flow
import en from "./en";
import de from "./de";

var stringsRepo = null;
function onStringsRepoUpdated(newStringRepo) {
    stringsRepo = newStringRepo;
}

export { en, de, stringsRepo, onStringsRepoUpdated };